import React from 'react';
import { DynamicModuleLoader } from 'redux-dynamic-modules';
import { getEditorModule } from './module';
const EditorModuleLoader = ()=>{
    return /*#__PURE__*/ React.createElement(DynamicModuleLoader, {
        modules: [
            getEditorModule()
        ]
    });
};
EditorModuleLoader.displayName = 'EditorModuleLoader';
export default EditorModuleLoader;

//# sourceMappingURL=EditorModuleLoader.js.map